<div class="checkbox-list">
<div class="checkbox-list-item checkbox checkbox-inline" [ngClass]="{'nested':item.isNested==true}" *ngFor="let item of items; let i = index" (click)="handleClick($event,item)">
  <input type="checkbox" id="inlineCheckbox{{i}}" value="option1" [(ngModel)]="item.isChecked" (click)="handleClick($event,item);false">
  <label for="inlineCheckbox{{i}}" title="{{item.display}}"> {{item.display}} </label>
  <p-toggleswitch [ngModel]="!item.isPrimary" (click)="handlePrimary($event,item);false" [ngClass]="{'hide':!item.isChecked}" styleClass="axisToggle"  ></p-toggleswitch>
</div>
</div>
